import { render, staticRenderFns } from "./SimilarPools.vue?vue&type=template&id=2f79317e&scoped=true&"
import script from "./SimilarPools.vue?vue&type=script&lang=js&"
export * from "./SimilarPools.vue?vue&type=script&lang=js&"
import style0 from "./SimilarPools.vue?vue&type=style&index=0&id=2f79317e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f79317e",
  null
  
)

export default component.exports